import React from 'react';

const localeEn = {
  header: {
    Home: undefined,
    'Property Search': undefined,
    'Find a REALTOR®': (
      <span>
        Find a REALTOR<sup>®</sup>
      </span>
    ),
    Resources: undefined,
    Favorites: undefined
  }
};

function getIn(path) {
  var stack = path.split('.');
  var object = localeEn;

  while (stack.length > 1 && object) {
    let key = stack.shift();
    object = object[key];
  }

  let key = stack.shift();
  return object && object[key] !== undefined ? object[key] : stack.pop() || key;
}

export default getIn;



// WEBPACK FOOTER //
// ./src/locale/locale-en.js